import { eLynxObjectTypeEnum } from "../enums/eLynxObjectType";

export const ALL_TAGS_CATEGORY_ID = 0;
export const SUMMARY_LISTING_TAGS_CATEGORY_ID = -20000;

export interface ITagCategory {
    id: number;
    text: string;
    order: number;
    objectID?: number;
    objectType?: eLynxObjectTypeEnum;
    expanded?: boolean;
    href?: string;

    selected?: boolean;
}
